import FacilityTagPicker from "components/FacilityTagPicker";
import { ManageTagsFormDialog } from "components/ManageTags";
import { EntityUpdate } from "components/ManageTags/types";
import { useCallback } from "react";
import { Row } from "routes/Staff/Implementation/OrganizationDetails/Facilities";

type ManageFacilityTagsFormDialogProps = {
  selectedRows: Row[];
  tenantId: string;
  onClose: () => void;
  onCloseConfirmation: () => void;
  confirm: () => void;
  open: boolean;
  withConfirmation?: boolean;
  showConfirmation: boolean;
  onSubmit: (facilityUpdates: { facilityId: string; tagNames: string[] }[]) => Promise<void>;
  loading: boolean;
};

export function ManageFacilityTagsFormDialog({
  selectedRows,
  tenantId,
  onClose,
  onCloseConfirmation,
  confirm,
  open,
  withConfirmation,
  showConfirmation,
  onSubmit,
  loading,
}: ManageFacilityTagsFormDialogProps) {
  const handleSubmit = useCallback(
    async (updates: EntityUpdate[]) => {
      await onSubmit(
        updates.map((update) => ({
          facilityId: update.id,
          tagNames: update.tags,
        }))
      );
    },
    [onSubmit]
  );

  return (
    <ManageTagsFormDialog<Row>
      selectedRows={selectedRows}
      getEntityId={(row) => row.id}
      tenantId={tenantId}
      onClose={onClose}
      onCloseConfirmation={onCloseConfirmation}
      confirm={confirm}
      open={open}
      withConfirmation={withConfirmation}
      showConfirmation={showConfirmation}
      onSubmit={handleSubmit}
      loading={loading}
      entityName="Facility"
      localStorageKey="facility-recent-tags"
      TagPickerComponent={(props) => <FacilityTagPicker {...props} tenantId={tenantId} />}
    />
  );
}
